import TabButtons from '@components/shared/TabButtons'
import SwapForm from '@components/swap/SwapForm'
import LimitForm from './LimitForm'
import { TabName, tradeTabsStore } from './tradeTabsStore'
import { useEffect, useCallback } from 'react'
import { useTranslation } from 'next-i18next'
import SlippageSettings from '@components/swap/SlippageSettings'

function setTab(tab: TabName) {
  tradeTabsStore.getState().actions.selectTab({ tab })
}

const tabsConfig = [
  ['swap', 0],
  ['limit', 0],
] as const satisfies [TabName, number][]

const TradeTabs = () => {
  const { t } = useTranslation('trade')
  const activeTab = tradeTabsStore((s) => s.activeTab.tab)
  const preserveInitialPrice = tradeTabsStore(
    (s) =>
      (s.activeTab.tab === 'limit' && s.activeTab.preserveInitialPrice) ??
      false,
  )

  useEffect(() => {
    // Reset the active tab to 'swap' when the component mounts
    tradeTabsStore.getState().actions.selectTab({ tab: 'swap' })
  }, [])

  const renderLabel = useCallback((tab: TabName) => t(`tabs.${tab}`), [t])

  return (
    <div>
      <TabButtons
        activeValue={activeTab}
        renderLabel={renderLabel}
        onChange={setTab}
        values={tabsConfig}
      />
      {activeTab === 'swap' ? (
        <div className="flex justify-end border-b border-th-bkg-3 px-6 py-2">
          <SlippageSettings />
        </div>
      ) : null}
      <div className="rounded-b-2xl py-2">
        {activeTab === 'swap' && <SwapForm />}
        {activeTab === 'limit' && (
          <LimitForm preserveInitialPrice={preserveInitialPrice} />
        )}
      </div>
    </div>
  )
}

export default TradeTabs
